import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=62f03d67"
import script from "./approver.vue?vue&type=script&lang=js"
export * from "./approver.vue?vue&type=script&lang=js"
import style0 from "./approver.vue?vue&type=style&index=0&id=62f03d67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports